<template>
  <div class="d-flex justify-content-center my-4">
    <div class="container m-0">
      <div class="row">
        <div class="offset-md-1 col-md-10 bottom-padding">
          <router-view />
          <BioUpgradeBanner v-if="canDisplayUpgradeBanner" class="mt-5" />
        </div>
      </div>
    </div>
    <router-view class="preview" name="preview" />
  </div>
</template>

<script>
import BioUpgradeBanner from '@/web/components/bio/BioUpgradeBanner.vue';
import { mapGetters } from 'vuex';
import { loadUserbackScript } from '@/web/utils/userback';

export default {
  name: 'BioTemplate',
  components: {
    BioUpgradeBanner,
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
      showBioUpgrade: 'globals/showBioUpgrade',
      showUserbackInStudio: 'globals/showUserbackInStudio',
    }),
    canDisplayUpgradeBanner() {
      return (
        this.showBioUpgrade &&
        this.teacher?.is_bio &&
        !this.$route.meta.hideUpgradeBanner
      );
    },
  },
  methods: {
    goToUpgrade() {
      this.$router.push({ name: 'bio-upgrade' });
      this.$emit('close');
    },
  },
  mounted() {
    if (this.showUserbackInStudio) {
      loadUserbackScript();
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.bottom-padding {
  padding-bottom: 8rem;
}
</style>
